<template>
  <div>
    <div class="p-6 pb-0">
      <BreadCrumbs :navigation="navigation" />
    </div>
    <div class="p-6 pb-0">
      <div class="flex items-center justify-between mb-4">
        <label class="block text-sm font-medium mb-2">{{ $t('gm.list_locations') }}</label>
      </div>


      <div v-if="showBinCreationModal" class="fixed inset-0 flex items-center justify-center z-50">
        <div class="absolute inset-0 bg-black opacity-50" @click="closeLineModal"></div>
        <div class="bg-white rounded-lg shadow-lg w-full max-w-xl p-6 relative my-auto">
          <h3 class="text-lg font-semibold mb-4">Aggiungi nuova ubicazione su {{ storage }} - {{ zone }} per articolo {{ itemForBintoCreate.Item }}</h3>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-2">

              <div class="mb-4">
                  <label class="block text-gray-700">Nome</label>
                  <input v-model="insertion.name" type="text" class="p93__input w-full" required autocomplete="nope">
              </div>

              <div class="mb-4">
                  <label class="block text-gray-700">Descrizione (facoltativa)</label>
                  <input v-model="insertion.description" type="text" class="p93__input w-full" required autocomplete="nope">
              </div>

              <div class="mb-4">
                  <label class="block text-gray-700">Verso</label>
                  <v-select 
                      :options="sides"
                      :reduce="side => side.id"
                      v-model="insertion.place_side"
                      label="desc"
                      placeholder="Seleziona verso..." 
                      class="w-full"
                  >
                  </v-select>
              </div>

              <div class="mb-4">
                  <label class="block text-gray-700">Passaggio</label>
                  <v-select 
                      :options="['A', 'B', 'C', 'D', 'E', 'F']"
                      v-model="insertion.passage_id"
                      label="desc"
                      placeholder="Seleziona passaggio..." 
                      class="w-full"
                  >
                  </v-select>
              </div>

              <div class="mb-3">
                  <label class="block text-gray-700 mb-1">Posizione</label>
                  <input v-model.number="insertion.position" type="number" min="1" step="1" class="w-full p-2 border border-gray-300 rounded-md" @keypress="onlyNumbers">
              </div>

              <div class="mb-3">
                  <label class="block text-gray-700 mb-1">Elevazione (mm)</label>
                  <input v-model.number="insertion.elevation" type="number" min="0" step="1" class="w-full p-2 border border-gray-300 rounded-md" @keypress="onlyNumbers">
              </div>

              <div class="mb-4">
                  <label class="block text-gray-700">Dimensioni (Lung x Larg mm)</label>
                  <v-select 
                      :options="dimensions"
                      :reduce="dimension => dimension.id"
                      v-model="insertion.dimensions_base"
                      label="desc"
                      placeholder="Seleziona dimensioni..." 
                      class="w-full"
                  >
                  </v-select>
              </div>

              <div class="mb-4">
                  <label class="block text-gray-700">Altezza (mm)</label>
                  <v-select 
                      :options="v_dimensions"
                      :reduce="dimension => dimension.id"
                      v-model="insertion.dimensions_v"
                      label="desc"
                      placeholder="Seleziona altezza..." 
                      class="w-full"
                  >
                  </v-select>
              </div>

              <div class="mb-3">
                  <label class="block text-gray-700 mb-1">Peso Massimo</label>
                  <input v-model.number="insertion.max_weight" type="number" min="0" step="1" class="w-full p-2 border border-gray-300 rounded-md" @keypress="onlyNumbers">
              </div>

              <div class="mb-3">
                  <label class="block text-gray-700 mb-1">Volume Massimo</label>
                  <input v-model.number="insertion.max_volume" type="number" min="0" step="1" class="w-full p-2 border border-gray-300 rounded-md" @keypress="onlyNumbers">
              </div>

              

              
            </div>
            
            <div class="flex justify-end mt-4 space-x-2">
              <button @click="showBinCreationModal = false" class="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400">
                Annulla
              </button>
              <button class="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 disabled:bg-blue-300" :disabled="!insertion.name || !insertion.passage_id || !insertion.place_side || !insertion.dimensions_base || !insertion.dimensions_v || insertion.max_weight === null || insertion.max_volume === null" @click="confirmInsertion">
                Salva
              </button>
            </div>
        </div>
      </div>
      
      <PageServerTable
        :headers="headers" 
        :items="items" 
        :items-per-page.sync="ipp" 
        :items-per-page-options="ippo" 
        :sort-by="sortby" 
        :items-length="count" 
        :reload-fn="reload"
        :item-value="'Item'"

        :page="page"
        show-current-page
        >
        <template #item.FixedBinPutaway="{ item }">
            <span v-if="item.FixedBinPutaway && item.FixedBinPutaway != ''">
              {{ item.FixedBinPutaway }}
            </span>
            <span v-else>
              <button class="text-white bg-blue-400 hover:bg-blue-500 font-medium rounded-lg text-sm px-5 py-2.5 text-center" @click="showInsertion(item)">Crea Ubicazione</button>
            </span>
        </template>
      </PageServerTable>
    </div>
    <div class="pb-24"></div>

    <ToastNotification :show="toast.show" :message="toast.message" :type="toast.type"
    @update:show="toast.show = $event" />
  </div>
</template>

<script setup>
import { Link, router, useForm } from '@inertiajs/vue3';
import BreadCrumbs from '@/Components/BreadCrumbs.vue';
import Pagination from '@/Components/Pagination.vue';
import PageServerTable from '@/Components/PageServerTable.vue';
import ToastNotification from '@/Components/ToastNotification.vue';
import axios from 'axios';
import { elementClosest } from '@fullcalendar/core/internal';
</script>

<script>
export default {
  props: ['items', 'count', 'ippo', 'storage', 'zone'],
  components: {
    Link,
    BreadCrumbs,
    Pagination,
    PageServerTable
  },
  data() {
    return {
      search: this.filters?.search || "",
      navigation: [
        { name: 'Dashboard', href: route('dashboard') },
        { name: this.$t('modules.gestione-magazzino'), href: route('modules.home', 'gestione-magazzino') },
        { name: this.$t('gm.gestione_ubicazioni_icam'), href: route('modules.gm.gestioneUbicazioniIcam') }
      ],
      selected: [],
      //deletions: [],
      headers: [],
      sortby: [],

      ipp: 10,
      page: 1,
      showBinCreationModal: false,
      itemForBintoCreate: null,
      sides: [
        { id: 1, desc: "Sinistra" },
        { id: 2, desc: "Destra" },
      ],
      dimensions: [
        { id: 1, length: 3600.00000, width: 1000.00000, desc: "3600 x 1000" },
        { id: 2, length: 4000.00000, width: 1000.00000, desc: "4000 x 1000" },
      ],
      v_dimensions: [
        {  id: 1, height: 1200.00000, desc: "1200" },
        {  id: 2, height: 1600.00000, desc: "1600" },
        {  id: 3, height: 2000.00000, desc: "2000" },
        {  id: 4, height: 2150.00000, desc: "2150" },
      ],
      insertion: {
      },
      toast: {
        show: false,
        message: '',
        type: 'success'
      }
    };
  },
  methods: {
    showToast(message, type = 'success') {
      this.toast.message = message;
      this.toast.type = type;
      this.toast.show = true;
    },
    showInsertion(item){
      this.insertion = {
        name: '',
        description: '',
        place_side: 1,
        dimensions_base: 1,
        dimensions_v: 1,
        max_weight: 100,
        max_volume: 100,
        passage_id: 'A',
        position: 1,
        elevation: 0
      };
      this.itemForBintoCreate = item; 
      this.showBinCreationModal = true
    },
    confirmInsertion(){
      axios
        .post(route('modules.gm.creaUbicazione'), {
        item: this.itemForBintoCreate.Item,
        name: this.insertion.name,
        description: this.insertion.description ?? '',
        dimensions_base: this.insertion.dimensions_base,
        dimensions_v: this.insertion.dimensions_v,
        max_weight: this.insertion.max_weight,
        max_volume: this.insertion.max_volume,
        place_side: this.insertion.place_side,
        passage_id: this.insertion.passage_id,
        elevation: this.insertion.elevation,
        position: this.insertion.position,
        storage: this.storage,
        zone: this.zone,
      })
      .then((response) => {
        console.log(response.data);
        if (response.data.success){
          this.showToast("Ubicazione creata con successo", 'success');
          this.showBinCreationModal = false;
          this.reload();
        }
        else if (response.data.success === false){
          this.showToast("Errore durante la creazione dell'ubicazione: " + response.data.message, 'error');
        }
        else {
          this.showToast("Errore durante la creazione dell'ubicazione: " + response.data, 'error');
        }
      });
    },
    reload(sortby = undefined, itemsperpage = undefined, page = undefined, afterdeletion = false) {
      /*if (afterdeletion)
      return;*/

        if (sortby) this.sortby = sortby;
        if (itemsperpage) this.ipp = itemsperpage;
        if (page) this.page = page;

        //sortBy e ipp passano solo il valore aggiornato come $event, non si modifica realmente, quindi ricaricare le prop
        router.post(window.location.href, { headers: this.headers, sortby: this.sortby, itemsperpage: this.ipp, page: this.page}, { only: ['items', 'count']});
    },
  },
  mounted()
  {
    //Primo caricamento
    this.headers = this.$attrs.headers;
    this.ipp = this.$attrs.ipp;
    this.page = this.$attrs.page;
    this.sortby = this.$attrs.sortby;
  }
};
</script>